/**
 * SSO via Gesthub.
 *
 * Fluxo:
 *   1. Frontend carrega → checa querystring `?sso_token=<jwt>`
 *      → se presente: salva em localStorage, limpa URL, recarrega clientes
 *   2. Se sem token E sem JWT no localStorage: redireciona pro Gesthub
 *      → Gesthub /api/auth/sso-emit?return_to=https://contabil...
 *      → Gesthub valida sessão própria, gera JWT HMAC, redireciona de volta
 *   3. Se já tem JWT: usa normal
 */
const GESTHUB_SSO_URL = 'https://gesthub.atriocontabilidade.com.br/api/auth/sso-emit';
const RETURN_URL = 'https://contabil.atriocontabilidade.com.br/';

export function captureSsoToken() {
  if (typeof window === 'undefined') return false;
  const url = new URL(window.location.href);
  const token = url.searchParams.get('sso_token');
  if (!token) return false;
  try {
    localStorage.setItem('atrio_jwt', token);
    // Limpa querystring sem reload
    url.searchParams.delete('sso_token');
    const clean = url.pathname + (url.search ? url.search : '') + url.hash;
    window.history.replaceState({}, '', clean);
    return true;
  } catch (e) {
    console.error('[sso] falha salvar token:', e);
    return false;
  }
}

export function hasJwt() {
  if (typeof localStorage === 'undefined') return false;
  return !!localStorage.getItem('atrio_jwt');
}

export function redirectToSso() {
  if (typeof window === 'undefined') return;
  const ret = encodeURIComponent(RETURN_URL);
  window.location.href = `${GESTHUB_SSO_URL}?return_to=${ret}`;
}

/**
 * Quem esta logado, lido do proprio token.
 *
 * A barra de cima mostrava um endereco fixo no codigo, sobra de quando a
 * autenticacao era o cabecalho X-User: dizia contato@atriocontabilidade.com.br
 * para qualquer pessoa, enquanto o sistema gravava no log o `sub` do JWT, que e
 * outro. Numa tela onde autoria e o que da valor ao registro, os dois tem que
 * ser a mesma coisa.
 *
 * Le sem verificar assinatura, de proposito: aqui e so rotulo. Quem valida o
 * token e a API, a cada chamada.
 */
export function usuarioLogado() {
  if (typeof localStorage === 'undefined') return null;
  const token = localStorage.getItem('atrio_jwt');
  if (!token) return null;
  try {
    const [, corpo] = token.split('.');
    if (!corpo) return null;
    // base64url: o atob nao entende - e _, e a sobra de padding.
    const b64 = corpo.replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(b64 + '='.repeat((4 - (b64.length % 4)) % 4))
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''));
    const p = JSON.parse(json);
    return {
      email: p.email || p.sub || null,
      nome:  p.name || p.nome || null,
      papeis: Array.isArray(p.roles) ? p.roles : [],
      expiraEm: p.exp ? new Date(p.exp * 1000) : null,
    };
  } catch {
    // Token estranho nao pode derrubar a barra: some o rotulo e pronto.
    return null;
  }
}

export function logout() {
  try { localStorage.removeItem('atrio_jwt'); } catch {}
  if (typeof window !== 'undefined') window.location.href = '/';
}

/**
 * Bootstrap: chama na montagem do App.
 * Retorna true se autenticou (com ou sem ação), false se vai redirect.
 */
export function bootstrapAuth() {
  // 1. Veio do SSO?
  if (captureSsoToken()) return true;
  // 2. Já tem JWT?
  if (hasJwt()) return true;
  // 3. Senão, redireciona pro Gesthub SSO
  redirectToSso();
  return false;
}
